module.exports = __webpack_public_path__ + "static/media/blog-hai-prompt.d78945a6.jpg";